var Map = {
  init(){
    this.mapContaier = $('#fnc-map');
    this.lat = this.mapContaier.data('lat');
    this.lng = this.mapContaier.data('lng');
    this.device = 'pc';

    this.check();
    this.event();
    this.render();
  },
  event(){
    $(window).on('resize.map', ()=>{
      this.check();
      this.render();
    });
  },
  check(){
    if( window.matchMedia('(min-width: 768px)').matches ){
      this.device = 'pc';
    }else{
      this.device = 'sp';
    }
  },
  render(){
    var position = {lat: this.lat, lng: this.lng};

    if( this.device === 'pc' ){
      var map = new google.maps.Map(document.getElementById('fnc-map'), {
        center: position,
        scrollwheel: false,
        zoom: 14
      });
    }else if( this.device === 'sp' ){
      var map = new google.maps.Map(document.getElementById('fnc-map'), {
        center: position,
        scrollwheel: false,
        zoomControl: false,
        scaleControl: false,
        streetViewControl: false,
        mapTypeControl: false,
        zoom: 14
      });
    }




    var marker = new google.maps.Marker({map: map, position: position});
  }
}

module.exports = Map;


// WEBPACK FOOTER //
// ./src/js/fncs/Map.js